export default __webpack_public_path__ + "static/media/1.37a8ed09.png";